import * as React from "react";

function SvgSearch(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.618 11.032a5.5 5.5 0 111.414-1.414l3.675 3.675-1.414 1.414-3.675-3.675zM6.5 10a3.5 3.5 0 100-7 3.5 3.5 0 000 7z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgSearch;
